import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as paymentRunTabControlState from '../reducers';
import * as paymentRunTabControlReducer from '../reducers/payment-run-tab-control.reducer';

export const selectPaymentRunTabIndex = createSelector(
  paymentRunTabControlState.selectPaymentRunTabControlState,
  paymentRunTabControlReducer.getPaymentRunTabControlIndex
);
